(function () {
  'use strict';

  var BUDGET_MIN = 500;
  var BUDGET_MAX = 100000;
  var BUDGET_RATIO = BUDGET_MAX / BUDGET_MIN;

  function formatEuros(value, locale) {
    return value.toLocaleString(locale || 'fr-FR') + ' €';
  }

  function niceRound(value) {
    if (value < 2000) return Math.round(value / 100) * 100;
    if (value < 10000) return Math.round(value / 500) * 500;
    return Math.round(value / 1000) * 1000;
  }

  function budgetFromT(t) {
    return niceRound(BUDGET_MIN * Math.pow(BUDGET_RATIO, t / 100));
  }

  function tFromBudget(v) {
    var clamped = Math.min(BUDGET_MAX, Math.max(BUDGET_MIN, v));
    return Math.round((Math.log(clamped / BUDGET_MIN) / Math.log(BUDGET_RATIO)) * 100);
  }

  /* Bareme indicatif en euros par carat, selon le niveau de teinte (1 a 5). */
  var PRICE_BY_TIER = { 1: 250, 2: 600, 3: 1200, 4: 2500, 5: 5000 };

  /* Le prix au carat progresse par paliers avec le poids, pas lineairement. */
  function sizeFactor(ct) {
    return Math.pow(Math.max(0.1, ct), 0.38);
  }

  function initSection(root) {
    if (!root || root.dataset.jcsInit === '1') return;
    root.dataset.jcsInit = '1';

    var form = root.querySelector('.jcs-form');
    if (!form) return;

    /* Libelles servis par les fichiers de langue du theme, pas ecrits en dur ici. */
    var T = {
      to: root.getAttribute('data-jcs-i18n-to') || 'à',
      forme: root.getAttribute('data-jcs-i18n-forme') || 'forme à préciser',
      poids: root.getAttribute('data-jcs-i18n-poids') || 'poids à préciser',
      locale: root.getAttribute('data-jcs-locale') || 'fr-FR'
    };

    var success = root.querySelector('[data-jcs-success]');
    if (success) {
      success.focus();
      return;
    }

    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-jcs-panel]'));
    var progress = root.querySelector('[data-jcs-progress]');
    var progressFill = root.querySelector('[data-jcs-progress-fill]');
    var stepNow = root.querySelector('[data-jcs-step-now]');
    var stepTitle = root.querySelector('[data-jcs-step-title]');
    var nav = root.querySelector('[data-jcs-nav]');
    var prevBtn = root.querySelector('[data-jcs-prev]');
    var nextBtn = root.querySelector('[data-jcs-next]');

    var customBox = form.querySelector('[data-jcs-poids-custom]');
    var customWrap = form.querySelector('[data-jcs-custom-wrap]');
    var customInput = form.querySelector('[data-jcs-poids-value]');
    var formeBox = form.querySelector('[data-jcs-forme-custom]');
    var formeWrap = form.querySelector('[data-jcs-forme-wrap]');
    var formeInput = form.querySelector('[data-jcs-forme-value]');

    var rangeMin = root.querySelector('[data-jcs-range-min]');
    var rangeMax = root.querySelector('[data-jcs-range-max]');
    var rangeMinLabel = root.querySelector('[data-jcs-range-min-label]');
    var rangeMaxLabel = root.querySelector('[data-jcs-range-max-label]');
    var rangeFill = root.querySelector('[data-jcs-range-fill]');
    var budgetHidden = root.querySelector('[data-jcs-budget]');
    var rangeAuto = root.querySelector('[data-jcs-range-auto]');
    var budgetTouched = false;
    var recapBudget = root.querySelector('[data-jcs-recap-budget]');
    var recaps = Array.prototype.slice.call(root.querySelectorAll('[data-jcs-recap]'));

    /* ----- groupes à choix multiples (agrégés dans un champ caché) ----- */
    var multiGroups = {};
    Array.prototype.forEach.call(form.querySelectorAll('[data-jcs-multi]'), function (box) {
      var name = box.getAttribute('data-jcs-multi');
      if (!multiGroups[name]) {
        multiGroups[name] = {
          boxes: [],
          hidden: form.querySelector('input[data-jcs-agg="' + name.replace(/"/g, '\\"') + '"]')
        };
      }
      multiGroups[name].boxes.push(box);
    });

    function collectGroup(name) {
      var group = multiGroups[name];
      if (!group) return [];
      var values = [];
      group.boxes.forEach(function (box) {
        if (!box.checked) return;
        if (box === formeBox) {
          var typedForme = formeInput && formeInput.value.trim() !== '' ? formeInput.value.trim() : T.forme;
          values.push(typedForme);
        } else {
          values.push(box.value);
        }
      });
      return values;
    }

    function setRecapSlot(slot, text) {
      if (text) {
        slot.textContent = text;
        slot.classList.remove('jcs-recap__empty');
      } else {
        slot.textContent = 'à définir';
        slot.classList.add('jcs-recap__empty');
      }
    }

    function syncAll() {
      Object.keys(multiGroups).forEach(function (name) {
        var joined = collectGroup(name).join(', ');
        if (multiGroups[name].hidden) multiGroups[name].hidden.value = joined;
      });
      recaps.forEach(function (slot) {
        var name = slot.getAttribute('data-jcs-recap');
        if (multiGroups[name]) {
          setRecapSlot(slot, collectGroup(name).join(', '));
        } else {
          var checked = form.querySelector('input[name="' + name.replace(/"/g, '\\"') + '"]:checked');
          var txt = checked ? checked.value : '';
          if (checked && customBox && checked === customBox) {
            txt = customInput && customInput.value.trim() !== '' ? customInput.value.trim() : T.poids;
          }
          setRecapSlot(slot, txt);
        }
      });
    }

    /* ----- budget : double curseur logarithmique ----- */
    function updateBudget(fromUser) {
      if (!rangeMin || !rangeMax) return;
      var tMin = parseInt(rangeMin.value, 10);
      var tMax = parseInt(rangeMax.value, 10);
      if (tMin > tMax - 2) {
        if (document.activeElement === rangeMax) {
          tMin = Math.max(0, tMax - 2);
          rangeMin.value = String(tMin);
        } else {
          tMax = Math.min(100, tMin + 2);
          rangeMax.value = String(tMax);
        }
      }
      var vMin = budgetFromT(tMin);
      var vMax = budgetFromT(tMax);
      var minTxt = formatEuros(vMin, T.locale);
      var maxTxt = formatEuros(vMax, T.locale);
      if (rangeMinLabel) rangeMinLabel.textContent = minTxt;
      if (rangeMaxLabel) rangeMaxLabel.textContent = maxTxt;
      if (rangeFill) {
        rangeFill.style.left = tMin + '%';
        rangeFill.style.width = (tMax - tMin) + '%';
      }
      if (fromUser) {
        if (budgetHidden) budgetHidden.value = minTxt + ' ' + T.to + ' ' + maxTxt;
        if (recapBudget) {
          recapBudget.textContent = minTxt + ' ' + T.to + ' ' + maxTxt;
          recapBudget.classList.remove('jcs-recap__empty');
        }
      }
    }

    /* ----- estimation automatique de la fourchette ----- */
    function estimateBudget() {
      var tiers = [];
      Array.prototype.forEach.call(form.querySelectorAll('[data-jcs-tier]'), function (box) {
        if (box.checked) tiers.push(parseInt(box.getAttribute('data-jcs-tier'), 10));
      });
      if (!tiers.length) return null;

      var ctMin = 0;
      var ctMax = 0;
      var weight = form.querySelector('input[name="contact[Poids]"]:checked');
      if (weight && weight.getAttribute('data-jcs-ct-min')) {
        ctMin = parseFloat(weight.getAttribute('data-jcs-ct-min'));
        ctMax = parseFloat(weight.getAttribute('data-jcs-ct-max'));
      } else if (weight && customBox && weight === customBox && customInput) {
        var typed = parseFloat(customInput.value.replace(',', '.').replace(/[^0-9.]/g, ''));
        if (typed > 0) { ctMin = typed * 0.9; ctMax = typed * 1.1; }
      }
      if (!ctMin || !ctMax) return null;

      var mult = 1;
      var treat = form.querySelector('input[data-jcs-mult]:checked');
      if (treat) mult = parseFloat(treat.getAttribute('data-jcs-mult'));

      var lowTier = Math.min.apply(null, tiers);
      var highTier = Math.max.apply(null, tiers);
      var lo = PRICE_BY_TIER[lowTier] * ctMin * sizeFactor(ctMin) * mult * 0.75;
      var hi = PRICE_BY_TIER[highTier] * ctMax * sizeFactor(ctMax) * mult * 1.3;
      if (hi < lo * 1.6) hi = lo * 1.6;
      return { lo: lo, hi: hi };
    }

    function applyEstimate() {
      if (budgetTouched || !rangeMin || !rangeMax) return;
      var est = estimateBudget();
      if (!est) {
        if (rangeAuto) rangeAuto.hidden = true;
        return;
      }
      var tLo = tFromBudget(est.lo);
      var tHi = tFromBudget(est.hi);
      if (tHi < tLo + 2) tHi = Math.min(100, tLo + 2);
      if (tLo > tHi - 2) tLo = Math.max(0, tHi - 2);
      rangeMin.value = String(tLo);
      rangeMax.value = String(tHi);
      updateBudget(true);
      if (rangeAuto) rangeAuto.hidden = false;
    }

    /* ----- assistant par étapes ----- */
    var current = 0;

    function activatePanel(index, focusTitle) {
      if (!panels.length) return;
      current = Math.max(0, Math.min(index, panels.length - 1));
      panels.forEach(function (panel, i) {
        panel.classList.toggle('jcs-panel--active', i === current);
      });
      if (stepNow) stepNow.textContent = String(current + 1);
      if (stepTitle) stepTitle.textContent = panels[current].getAttribute('data-jcs-title') || '';
      if (progressFill) progressFill.style.width = (((current + 1) / panels.length) * 100).toFixed(2) + '%';
      if (prevBtn) prevBtn.hidden = current === 0;
      if (nextBtn) nextBtn.hidden = current === panels.length - 1;
      if (focusTitle) {
        var title = panels[current].querySelector('.jcs-panel__title');
        if (title) title.focus({ preventScroll: true });
        var top = form.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    if (panels.length) {
      form.classList.add('jcs-wizard');
      if (progress) progress.hidden = false;
      if (nav) nav.hidden = false;
      activatePanel(0, false);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () { activatePanel(current + 1, true); });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { activatePanel(current - 1, true); });
    }

    /* ----- interactions ----- */
    form.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;
      if (customBox && customWrap && (target === customBox || (target.type === 'radio' && target.name === 'contact[Poids]'))) {
        customWrap.hidden = !customBox.checked;
        if (customBox.checked && customInput) customInput.focus();
      }
      if (target === formeBox && formeWrap) {
        formeWrap.hidden = !formeBox.checked;
        if (formeBox.checked && formeInput) formeInput.focus();
      }
      if (target.type === 'checkbox' || target.type === 'radio') {
        syncAll();
        if (target.hasAttribute('data-jcs-tier') || target.name === 'contact[Poids]' || target.hasAttribute('data-jcs-mult')) {
          applyEstimate();
        }
      }
    });

    if (customInput) {
      customInput.addEventListener('input', function () { syncAll(); applyEstimate(); });
    }

    if (formeInput) {
      formeInput.addEventListener('input', syncAll);
    }

    if (rangeMin && rangeMax) {
      rangeMin.addEventListener('input', function () { budgetTouched = true; if (rangeAuto) rangeAuto.hidden = true; updateBudget(true); });
      rangeMax.addEventListener('input', function () { budgetTouched = true; if (rangeAuto) rangeAuto.hidden = true; updateBudget(true); });
      updateBudget(false);
    }

    syncAll();
    applyEstimate();
  }

  function initAll(context) {
    var roots = (context || document).querySelectorAll('[data-jcs-root]');
    Array.prototype.forEach.call(roots, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
